var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$store.getters.loading)?_c('div',[_c('toolbar'),_c('div',{staticClass:"row"},[(_vm.onlyDesktop)?_c('dashboard',{staticClass:"spacer"}):_vm._e(),_c('virtualApp')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }